import {gql, useMutation} from "@apollo/client";

const qlBrandHouseCreate = gql`
    mutation BrandHouseCreate($name: String!, $logisticsPartnerId: String!) {
      BrandHouseCreate(name:$name, logisticsPartnerId: $logisticsPartnerId) {
        _id
        name
      }
    }
`

export type BrandHouseCreate = {
   _id: string
   name: string
}

const useBrandHouseCreate = () => {
   const [brandHouseCreate] = useMutation(qlBrandHouseCreate);

   return async (name: string, logisticsPartnerId: string): Promise<BrandHouseCreate | undefined> => {
      let result = await brandHouseCreate({
         variables: {
            name,
            logisticsPartnerId
         },
         update(cache, {data}) {
            cache.evict(data.BrandHouseCreate._id);
         }
      });
      return result?.data?.BrandHouseCreate as BrandHouseCreate
   }
}

export default useBrandHouseCreate;
